var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCloseIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12.205,
    height: 18,
    viewBox: "0 0 12.205 12",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "closeIcon",
    transform: "translate(-386.795 -532)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "left-arrow",
    transform: "translate(391.95 532)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_43",
    "data-name": "Group 43",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_53",
    "data-name": "Path 53",
    d: "M103.849,6l4.489-4.489a.658.658,0,0,0,0-.928l-.393-.393a.658.658,0,0,0-.928,0l-5.345,5.345a.662.662,0,0,0,0,.932l5.34,5.34a.658.658,0,0,0,.928,0l.393-.393a.657.657,0,0,0,0-.928Z",
    transform: "translate(-101.48 0)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "left-arrow-2",
    "data-name": "left-arrow",
    transform: "translate(386.795 532)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_43-2",
    "data-name": "Group 43",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_53-2",
    "data-name": "Path 53",
    d: "M106.161,6l-4.489-4.489a.658.658,0,0,1,0-.928l.393-.393a.658.658,0,0,1,.928,0l5.345,5.345a.662.662,0,0,1,0,.932L103,11.808a.658.658,0,0,1-.928,0l-.393-.393a.657.657,0,0,1,0-.928Z",
    transform: "translate(-101.48 0)"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseIcon);
export default __webpack_public_path__ + "static/media/closeIcon.3bc565af0451cec38b3ebea6897c0b0f.svg";
export { ForwardRef as ReactComponent };